import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form'
import { clearServer, fetchServer, newServer, persistServer, deleteServer } from '../store/actions/servers';
import { fetchCountries} from '../store/actions/countries';
import ServerForm from '../components/serverForm';
import { withLoadingComponent, withErrorComponent } from '../components/loading';
import { authRedirect } from '../lib/utils';
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, ownProps) => {
    const selectedCountries = (state.server.server && state.server.server.countries ? state.server.server.countries:[]).map(g=>(g));
    const availableCountries = (state.countries.countries?state.countries.countries:[]).map((g)=>{
        return {
            label: g.name,
            value: g.countryCode
        };
    });

    return {
        ...state.server,
        initialValues: {
            ...state.server.server,
            selectedCountries,
        },
        availableCountries,
        loading: state.servers.loading || state.countries.loading
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const serverId = ownProps.match.params.serverId;
    return {
        clearServer: () => {
            dispatch(clearServer())
        },
        fetchServer: () => {
            if('new' === serverId) {
                dispatch(newServer())
            } else {
                dispatch(fetchServer(serverId)).catch(authRedirect(ownProps))
            }
        },
        deleteServer: () => {
            dispatch(deleteServer(serverId)).then(r => {
                ownProps.history.push(`/servers`)
            })
        },
        fetchCountries: () => {
            dispatch(fetchCountries())
        },
        onSubmit: (data) => {
            const server = {...data, countries: []};
            data.selectedCountries.forEach(g=>{
                server.countries.push(g)
            });
            dispatch(persistServer(server)).then(r => {
                ownProps.history.push(`/servers`)
            })
        },
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchServer();
        this.props.fetchCountries();
    },
    componentWillUnmount(){
        this.props.clearServer()
    }
};

export default compose(
        withRouter,
        connect(mapStateToProps, mapDispatchToProps),
        lifecycle(lifecycleValue),
        withErrorComponent,
        withLoadingComponent,
        reduxForm({form: 'serverForm'}),
        withHandlers({
            onBackClick: props => () =>{alert("Back")}
        })
)(ServerForm);


// WEBPACK FOOTER //
// ./src/containers/ServerContainer.js